module.exports = __webpack_public_path__ + "static/media/siddhi_landage.4d4b19ee.png";